export default {
  definitions: {
    presentation: require('./presentation').default,
  },
}



// WEBPACK FOOTER //
// ./src/content/vychovakzivotu/addons/socialShare/index.js